import { createFileRoute } from "@tanstack/react-router";
import { redirectToHome } from "@/lib/locked-route";

// Locked for the MVP: the address sends the person back Home.
export const Route = createFileRoute("/_authenticated/skills")({ beforeLoad: redirectToHome });
